<template>
	<div class="m-search">
		<div class="m-search-hadnle flex-center-cross">
			<c-button class="button" @click="search">查询</c-button>
			<c-button class="button" color="gray" hollow @click="clear">重置</c-button>
		</div>
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'mSearch',
		
		mounted() {
			this.$form = this.$children.find(item => item.$options.name == 'cForm');
		},

		methods: {
			search() {
				var data = this.$form.serialize();
				this.$emit('search', data);
			},
			
			clear() {
				this.$form.clear();
			}
		}
	}
</script>

<style lang="stylus">
	.m-search {
		padding-bottom: 20px;
		
		&-hadnle {
			.button {
				width: 74px;
				margin-right: 8px;
				
				elder({
					width: 100px,
					margin-right: 14px
				})
			}
		}
		
		.c-form {
			padding: 20px 0 0;
			
			&-item {
				&-label {
					height: 36px;
					
					elder({
						height: 44px
					})
				}
				
				.c-input {
					height: 36px !important;
					
					elder({
						height: 44px !important
					})
				}
				
				.c-radio, .c-checkbox {
					margin-top: 5px;
				}
				
				.c-select {
					height: 36px;
					
					elder({
						height: 44px
					})
					
					&-options-item {
						line-height: 36px;
						
						elder({
							line-height: 44px,
							font-size: 22px
						})
					}
				}
				
				.c-datetime {
					.el-date-editor {
						.el-input__inner {
							height: 30px;
						}
						
						.el-input__icon {
							line-height: 30px;
						}
					}
			
					.el-range-editor {
						height: 30px;
							
						.el-range-input {
							vertical-align: top;
							height: 28px;
						}
						
						.el-range-separator {
							vertical-align: top;
							height: 28px;
							line-height: 28px;
						}
						
						.el-input__icon {
							line-height: 28px;
						}
					}
				}
			}
		}
	}
</style>
